import './polyfills';
import './bootstrap';
import './vue';
import './gitlab_ui';
import './duo_ui';
import '../lib/utils/axios_utils';
